<div class="unsupported-browsers__wrapper">
  <span
    class="unsupported-browsers__icon"
    nz-icon
    nzType="aio:warning-circle-regular"></span>
  <h2 class="unsupported-browsers__title">Your Browser Isn't Supported</h2>
  <p class="unsupported-browsers__description">
    This application is optimized exclusively for these browsers:
  </p>
  <div class="unsupported-browsers__container">
    <h4 class="unsupported-browsers__subtitle">Required Browsers</h4>
    <div class="unsupported-browsers">
      <div class="unsupported-browsers__item">
        <img src="assets/images/edge-logo.png" alt="edge-logo" />
      </div>
      <div class="unsupported-browsers__item">
        <img src="assets/images/chrome-logo.png" alt="chrome-logo" />
      </div>
    </div>
    <p class="unsupported-browsers__version">
      Version {{ browserVersionSupported }} or higher
    </p>
  </div>
</div>
